import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Card, CardBody, CardTitle, CardText, Button, Col, Row, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMedal, faUser, faStar, faTimes } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import dummy from "./../../assets/dummy.png";  
const districtPersons = {
  "Charkhi Dadri": [
    // {
    //   name: "Shri Dharam Prakash",
    //   rank: "Capt(Hony)",
    //   unit: "NA",
    //   award: "Sena Medal",
    //   address: "VPO – Jansui",
    //   contact: "9996961451",
    //   bio: "",
    //   image: dummy,
    // },
],
}

const MedalDetail = () => {
   const { districtName } = useParams();
    const persons = districtPersons[districtName] || [];
    const [modal, setModal] = useState(false);
    const [selectedPerson, setSelectedPerson] = useState(null);

    const toggleModal = (person) => {
        setSelectedPerson(person);
        setModal(!modal);
    };

    return (
        <>
            <div style={{
                backgroundImage: `url(${footerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '30px 0',
                color: 'white',
                margin: '2%',
                borderRadius: '10px'
            }}>
                <Container>
                    <h3 className="fw-bold mb-0 text-center">
                        <FontAwesomeIcon icon={faMedal} className="me-2" />
                        {districtName} Gallantry Awardees
                    </h3>
                </Container>
            </div>

            <Container className="py-5">
                <Row className="justify-content-center">
                    {persons.length === 0 ? (
                        <Col lg={12}>
                            <Card className="border-0 text-center" style={{ borderRadius: '20px', padding: '50px', boxShadow: '0 12px 40px rgba(0,0,0,0.1)' }}>
                                <FontAwesomeIcon icon={faStar} style={{ fontSize: '3rem', color: '#6c757d', marginBottom: '20px' }} />
                                <h5 style={{ color: '#6c757d' }}>No Details available for {districtName} district.</h5>
                            </Card>
                        </Col>
                    ) : (
                        persons.map((person, index) => (
                            <Col key={index} md="4" xs="12" sm="6" className="mb-4">
                                <Card className="h-100 border-0" style={{ 
                                    borderRadius: '20px', 
                                    overflow: 'hidden',
                                    boxShadow: '0 8px 32px rgba(30,60,114,0.15)',
                                    transition: 'all 0.3s ease'
                                }}>
                                    <div style={{
                                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                                        padding: '20px',
                                        position: 'relative'
                                    }}>
                                        <div className="d-flex justify-content-center">
                                            <img
                                                src={person.image || dummy}
                                                alt={person.name}
                                                style={{
                                                    width: '100px',
                                                    height: '100px',
                                                    borderRadius: '50%',
                                                    border: '4px solid rgba(255,255,255,0.3)',
                                                    objectFit: 'cover',
                                                    boxShadow: '0 8px 25px rgba(0,0,0,0.2)'
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <CardBody className="text-center p-4">
                                        <CardTitle tag="h5" className="fw-bold mb-2" style={{ color: '#1e3c72' }}>
                                            {person.name}
                                        </CardTitle>
                                        <CardText style={{ color: '#8e44ad', fontWeight: '600' }}>
                                            <FontAwesomeIcon icon={faStar} className="me-2" />
                                            {person.award}
                                        </CardText>
                                        <Button 
                                            style={{
                                                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                                                border: 'none',
                                                borderRadius: '20px',
                                                padding: '10px 25px',
                                                fontWeight: '600'
                                            }} 
                                            onClick={() => toggleModal(person)}
                                            onMouseOver={(e) => {
                                                e.currentTarget.style.background = 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)';
                                                e.currentTarget.style.transform = 'scale(1.05)';
                                            }}
                                            onMouseOut={(e) => {
                                                e.currentTarget.style.background = 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)';
                                                e.currentTarget.style.transform = 'scale(1)';
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faUser} className="me-2" />
                                            View Profile
                                        </Button>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))
                    )}
                </Row>
            </Container>

            <Modal isOpen={modal} toggle={() => toggleModal(null)} centered size="lg">
                <ModalHeader 
                    toggle={() => toggleModal(null)}
                    style={{
                        background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                        color: 'white',
                        border: 'none'
                    }}
                >
                    <FontAwesomeIcon icon={faMedal} className="me-2" />
                    {selectedPerson?.name}
                </ModalHeader>
                <ModalBody className="p-4">
                    {selectedPerson && (
                        <Row>
                            <Col md="4" className="d-flex justify-content-center align-items-center mb-4 mb-md-0">
                                <img
                                    src={selectedPerson.image || dummy}
                                    alt={selectedPerson.name}
                                    style={{
                                        width: '150px',
                                        height: '150px',
                                        borderRadius: '50%',
                                        border: '4px solid #8e44ad',
                                        objectFit: 'cover',
                                        boxShadow: '0 8px 25px rgba(142,68,173,0.3)'
                                    }}
                                />
                            </Col>
                            <Col md="8">
                                <div className="ps-md-4">
                                    <h5 className="fw-bold mb-3" style={{ color: '#8e44ad' }}>
                                        <FontAwesomeIcon icon={faStar} className="me-2" />
                                        {selectedPerson.award}
                                    </h5>
                                    
                                    <div className="mb-3">
                                        <small style={{ color: '#1e3c72', fontWeight: '600' }}>Rank</small>
                                        <p style={{ color: '#495057' }}>{selectedPerson.rank}</p>
                                    </div>
                                    
                                    <div className="mb-3">
                                        <small style={{ color: '#1e3c72', fontWeight: '600' }}>Unit</small>
                                        <p style={{ color: '#495057' }}>{selectedPerson.unit}</p>
                                    </div>
                                    
                                    <div className="mb-3">
                                        <small style={{ color: '#1e3c72', fontWeight: '600' }}>Permanent Address</small>
                                        <p style={{ color: '#495057' }}>{selectedPerson.address}</p>
                                    </div>
                                    
                                    <div className="mb-3">
                                        <small style={{ color: '#1e3c72', fontWeight: '600' }}>Contact</small>
                                        <p style={{ color: '#495057' }}>{selectedPerson.contact}</p>
                                    </div>
                                    
                                    {selectedPerson.bio && (
                                        <div>
                                            <small style={{ color: '#1e3c72', fontWeight: '600' }}>Details</small>
                                            <p style={{ color: '#495057', lineHeight: '1.7' }}>{selectedPerson.bio}</p>
                                        </div>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    )}
                </ModalBody>
                <ModalFooter style={{ borderTop: '1px solid #e9ecef', background: '#f8f9fa' }}>
                    <Button
                        style={{
                            background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 25px',
                            fontWeight: '600'
                        }}
                        onClick={() => toggleModal(null)}
                    >
                        <FontAwesomeIcon icon={faTimes} className="me-2" />
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default MedalDetail;
